export default __webpack_public_path__ + "static/media/CGTicon.be5b7ef4.svg";